module.exports = __webpack_public_path__ + "img/icon-class-empty.86cdbdb1.png";